let memoryStore = new Map();

export function get(key) {
    try {
        return localStorage && localStorage.getItem(key) || memoryStore.get(key);
    } catch (e) {
        return memoryStore.get(key);
    }
}

export function set(key, value) {
    memoryStore.set(key, value);
    try {
        if (localStorage) {
            localStorage.setItem(key, value);
        }
    } catch (e) {
    }
}

export function remove(key) {
    memoryStore.delete(key);
    try {
        if (localStorage) {
            localStorage.removeItem(key);
        }
    } catch (e) {
    }
}

export function setJson(key, value) {
    set(key, JSON.stringify(value));
}

export function getJson(key) {
    try {
        return JSON.parse(get(key));
    } catch (e) {
    }
}
